type AdvantageCardProps = {
    title: string;
    description: string;
    icon: React.ReactNode;
    tinted?: boolean;
  };
  
  export const AdvantageCard = ({
    title,
    description,
    icon,
    tinted = false,
  }: AdvantageCardProps) => {
    return (
     <div>
      <div className="hidden lg:block">
         <div
        className={`
          rounded-[36px]
          border border-[#F3EEEE]
          shadow-[0px_8px_28px_rgba(0,0,0,0.06)]
          px-7 pt-7 pb-8
          min-h-[266px]
          ${
            tinted
              ? "bg-[linear-gradient(180deg,#F7EEEE_0%,#F4ECEC_100%)]"
              : "bg-white"
          }
        `}
      >
        <div className="mb-10">{icon}</div>
  
        <h3 className="text-[#171717] text-[20px] leading-[1.2] font-medium">
          {title}
        </h3>
  
        <p className="mt-4 text-[#2B2B2B] text-[16px] leading-[1.45] max-w-[300px]">
          {description}
        </p>
      </div>
      </div>

      <div className="block lg:hidden">
         <div
        className={`
          rounded-[36px]
          border border-[#F3EEEE]
          shadow-[0px_8px_28px_rgba(0,0,0,0.06)]
          px-6 py-4
          h-[230px]
          ${
            tinted
              ? "bg-[linear-gradient(180deg,#F7EEEE_0%,#F4ECEC_100%)]"
              : "bg-white"
          }
        `}
      >
        <div className="mb-10 w-2 h-2">{icon}</div>
  
        <h3 className="text-[#171717] text-[14px] leading-[1.2] font-medium">
          {title}
        </h3>
  
        <p className="mt-4 text-[#2B2B2B] text-[12px] leading-[1.45] max-w-[300px]">
          {description}
        </p>
      </div>
      </div>
     </div>
    );
  };